export default __webpack_public_path__ + "bfx/static/media/back_icon_merch.46aeff30.svg";